import React from "react"
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import CloseIcon from "@mui/icons-material/Close"
import { COLORS } from "../../../../utils"

const DeliveryModal = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  onBack,
  leftLabel,
  onLeft,
  submitLabel,
  onSubmit,
  isSubmitType = false,
  onFormSubmit,
  submitDisabled = false,
  isSubmitting = false,
  dialogSx,
}) => (
  <Dialog open={open} onClose={onClose} sx={[sx.dialog, dialogSx]}>
    <Box component="form" onSubmit={onFormSubmit} sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <DialogTitle sx={sx.title}>
        {onBack && (
          <IconButton onClick={onBack} sx={sx.backBtn} aria-label="Retour">
            <ArrowBackIcon fontSize="small" />
          </IconButton>
        )}
        <Box sx={sx.titleText}>
          <Typography sx={sx.titleMain}>{title}</Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={sx.titleSub}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <IconButton onClick={onClose} disabled={isSubmitting} sx={sx.closeBtn} aria-label="Fermer">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={sx.content}>{children}</DialogContent>

      <DialogActions sx={sx.actions}>
        <Button variant="text" onClick={onLeft} disabled={isSubmitting} sx={sx.leftBtn}>
          {leftLabel}
        </Button>
        <Button
          variant="contained"
          type={isSubmitType ? "submit" : "button"}
          onClick={isSubmitType ? undefined : onSubmit}
          disabled={isSubmitting || submitDisabled}
          startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
          sx={sx.submitBtn}
        >
          {isSubmitting ? "Création…" : submitLabel}
        </Button>
      </DialogActions>
    </Box>
  </Dialog>
)

const sx = {
  dialog: {
    "& .MuiDialog-paper": {
      width: 520,
      maxWidth: "calc(100vw - 32px)",
      borderRadius: "12px",
      boxShadow: "0 12px 40px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)",
      overflow: "hidden",
    },
  },
  title: {
    px: 5,
    pt: 3,
    pb: 1,
    display: "flex",
    alignItems: "flex-start",
    gap: 0.75,
    pr: 6,
  },
  titleText: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  },
  titleMain: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.3,
    color: "text.primary",
  },
  titleSub: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.4,
  },
  backBtn: {
    color: "text.secondary",
    mt: 0.25,
    ml: -0.5,
    flexShrink: 0,
  },
  closeBtn: {
    position: "absolute",
    right: 24,
    top: 12,
    color: "text.secondary",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
    px: 5,
    paddingTop: "24px !important",
    paddingBottom: "8px !important",
    overflowY: "auto",
    flex: "1 1 auto",
    minHeight: 0,
  },
  actions: {
    px: 5,
    paddingTop: "24px !important",
    paddingBottom: "32px !important",
    justifyContent: "space-between",
  },
  leftBtn: {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: "0.04em",
    px: 2,
    py: "10px",
    color: COLORS.PRIMARY_COLOR,
  },
  submitBtn: {
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: "0.04em",
    px: "28px",
    py: "12px",
    borderRadius: 1,
    boxShadow: `0 2px 4px ${COLORS.PRIMARY_COLOR}33`,
  },
}

export default DeliveryModal
